/**
 * Custom JavaScript for code that must run before deferred scripts.
 * Keep this file small because it is loaded synchronously in the document head.
 */

window.CustomShopify = window.CustomShopify || {};
window.CustomShopify.immediateReady = true;

window.CustomShopify.Cookies = (function () {
  var DEFAULT_PATH = "/";
  var DEFAULT_SAME_SITE = "Lax";
  var SECONDS_PER_DAY = 86400;

  /**
   * @param {unknown} value
   * @returns {string}
   */
  function encode(value) {
    return encodeURIComponent(String(value));
  }

  /**
   * @param {string} value
   * @returns {string}
   */
  function decode(value) {
    try {
      return decodeURIComponent(value);
    } catch (error) {
      return value;
    }
  }

  /**
   * @param {string} name
   * @returns {string | false}
   */
  function findCookie(name) {
    if (!name || !document.cookie) {
      return false;
    }

    var encodedName = encode(name) + "=";
    var cookies = document.cookie.split("; ");

    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index];

      if (!cookie) {
        continue;
      }

      if (cookie.indexOf(encodedName) === 0) {
        return decode(cookie.slice(encodedName.length));
      }
    }

    return false;
  }

  /**
   * @param {number} days
   * @returns {number}
   */
  function normalizeDays(days) {
    var parsedDays = Number(days);

    if (!Number.isFinite(parsedDays)) {
      throw new TypeError("Cookie duration must be a valid number of days.");
    }

    return parsedDays;
  }

  /**
   * @param {number} days
   * @returns {string}
   */
  function serializeOptions(days) {
    var maxAge = Math.round(normalizeDays(days) * SECONDS_PER_DAY);
    var serialized =
      "; Max-Age=" +
      maxAge +
      "; Path=" +
      DEFAULT_PATH +
      "; SameSite=" +
      DEFAULT_SAME_SITE;

    if (window.location.protocol === "https:") {
      serialized += "; Secure";
    }

    return serialized;
  }

  /**
   * @param {string} name
   * @param {unknown} value
   * @param {number} days
   * @returns {boolean}
   */
  function writeCookie(name, value, days) {
    if (!name) {
      throw new TypeError("Cookie name is required.");
    }

    document.cookie =
      encode(name) + "=" + encode(value) + serializeOptions(days);
    return true;
  }

  /**
   * @param {string} name
   * @returns {string | false}
   */
  function getString(name) {
    return findCookie(name);
  }

  /**
   * @param {string} name
   * @param {string} value
   * @param {number} days
   * @returns {boolean}
   */
  function setString(name, value, days) {
    return writeCookie(name, value, days);
  }

  /**
   * @template T
   * @param {string} name
   * @returns {T | false}
   */
  function getJson(name) {
    var value = findCookie(name);

    if (value === false) {
      return false;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return false;
    }
  }

  /**
   * @param {string} name
   * @param {unknown} value
   * @param {number} days
   * @returns {boolean}
   */
  function setJson(name, value, days) {
    return writeCookie(name, JSON.stringify(value), days);
  }

  /**
   * @param {string} name
   * @returns {boolean}
   */
  function remove(name) {
    if (!name) {
      return false;
    }

    document.cookie =
      encode(name) +
      "=; Expires=Thu, 01 Jan 1970 00:00:00 GMT" +
      serializeOptions(0);
    return true;
  }

  return {
    getString: getString,
    setString: setString,
    getJson: getJson,
    setJson: setJson,
    remove: remove,
  };
})();

window.CustomShopify.IubendaPolicyModal = (function () {
  var SCRIPT_SRC = "https://cdn.iubenda.com/iubenda.js";
  var BADGE_SCRIPT_SRC = "https://cdn.iubenda.com/iubenda_i_badge.js";
  var CDN_BASE_URL = "https://cdn.iubenda.com/";
  /** @type {Array<() => void>} */
  var callbacks = [];
  /** @type {Array<() => void>} */
  var errorCallbacks = [];
  /** @type {Array<() => void>} */
  var badgeCallbacks = [];
  /** @type {Array<() => void>} */
  var badgeErrorCallbacks = [];
  var scriptRequested = false;
  var scriptLoaded = false;
  var badgeScriptRequested = false;
  var badgeScriptLoaded = false;

  /**
   * @returns {{ enabled?: boolean, policyId?: string } | null}
   */
  function getConfig() {
    var config = window.CustomShopify.IubendaPolicyConfig;

    if (!config || typeof config !== "object") {
      return null;
    }

    return config;
  }

  /**
   * @returns {boolean}
   */
  function isEnabled() {
    var config = getConfig();

    return Boolean(
      config &&
        config.enabled &&
        typeof config.policyId === "string" &&
        config.policyId.trim(),
    );
  }

  /**
   * @param {string} scriptSrc
   * @returns {HTMLScriptElement | null}
   */
  function findExistingScript(scriptSrc) {
    var scripts = document.querySelectorAll("script[src]");

    for (var index = 0; index < scripts.length; index += 1) {
      var script = scripts[index];

      if (!script) {
        continue;
      }

      if (
        script instanceof HTMLScriptElement &&
        script.src.indexOf(scriptSrc) === 0
      ) {
        return script;
      }
    }

    return null;
  }

  /**
   * @returns {void}
   */
  function flushCallbacks() {
    var pendingCallbacks = callbacks.slice();
    callbacks = [];
    errorCallbacks = [];

    for (var index = 0; index < pendingCallbacks.length; index += 1) {
      var callback = pendingCallbacks[index];

      if (callback) {
        callback();
      }
    }
  }

  /**
   * @returns {void}
   */
  function flushErrorCallbacks() {
    var pendingCallbacks = errorCallbacks.slice();
    callbacks = [];
    errorCallbacks = [];

    for (var index = 0; index < pendingCallbacks.length; index += 1) {
      var callback = pendingCallbacks[index];

      if (callback) {
        callback();
      }
    }
  }

  /**
   * @returns {void}
   */
  function flushBadgeCallbacks() {
    var pendingCallbacks = badgeCallbacks.slice();
    badgeCallbacks = [];
    badgeErrorCallbacks = [];

    for (var index = 0; index < pendingCallbacks.length; index += 1) {
      var callback = pendingCallbacks[index];

      if (callback) {
        callback();
      }
    }
  }

  /**
   * @returns {void}
   */
  function flushBadgeErrorCallbacks() {
    var pendingCallbacks = badgeErrorCallbacks.slice();
    badgeCallbacks = [];
    badgeErrorCallbacks = [];

    for (var index = 0; index < pendingCallbacks.length; index += 1) {
      var callback = pendingCallbacks[index];

      if (callback) {
        callback();
      }
    }
  }

  /**
   * @param {() => void} [callback]
   * @param {() => void} [errorCallback]
   * @returns {void}
   */
  function load(callback, errorCallback) {
    if (!isEnabled()) {
      return;
    }

    if (callback) {
      callbacks.push(callback);
    }

    if (errorCallback) {
      errorCallbacks.push(errorCallback);
    }

    if (scriptLoaded) {
      window.setTimeout(flushCallbacks, 0);
      return;
    }

    if (scriptRequested) {
      return;
    }

    if (findExistingScript(SCRIPT_SRC)) {
      scriptLoaded = true;
      window.setTimeout(flushCallbacks, 0);
      return;
    }

    scriptRequested = true;

    var script = document.createElement("script");
    var firstScript = document.getElementsByTagName("script")[0];

    script.type = "text/javascript";
    script.src = SCRIPT_SRC;
    script.onload = function () {
      scriptLoaded = true;
      flushCallbacks();
    };

    script.onerror = function () {
      scriptRequested = false;
      script.remove();
      flushErrorCallbacks();
    };

    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
      return;
    }

    document.head.appendChild(script);
  }

  /**
   * @param {() => void} [callback]
   * @param {() => void} [errorCallback]
   * @returns {void}
   */
  function loadBadge(callback, errorCallback) {
    if (!isEnabled()) {
      return;
    }

    if (callback) {
      badgeCallbacks.push(callback);
    }

    if (errorCallback) {
      badgeErrorCallbacks.push(errorCallback);
    }

    if (badgeScriptLoaded || getStartBadge()) {
      badgeScriptLoaded = true;
      window.setTimeout(flushBadgeCallbacks, 0);
      return;
    }

    if (badgeScriptRequested) {
      return;
    }

    var existingScript = findExistingScript(BADGE_SCRIPT_SRC);

    if (existingScript) {
      badgeScriptRequested = true;
      existingScript.addEventListener(
        "load",
        function () {
          badgeScriptLoaded = true;
          flushBadgeCallbacks();
        },
        { once: true },
      );
      existingScript.addEventListener(
        "error",
        function () {
          badgeScriptRequested = false;
          flushBadgeErrorCallbacks();
        },
        { once: true },
      );
      return;
    }

    badgeScriptRequested = true;

    var script = document.createElement("script");
    var firstScript = document.getElementsByTagName("script")[0];

    script.type = "text/javascript";
    script.src = BADGE_SCRIPT_SRC;
    script.onload = function () {
      badgeScriptLoaded = true;
      flushBadgeCallbacks();
    };

    script.onerror = function () {
      badgeScriptRequested = false;
      script.remove();
      flushBadgeErrorCallbacks();
    };

    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
      return;
    }

    document.head.appendChild(script);
  }

  /**
   * @returns {((options: {
   *   linkA: HTMLAnchorElement,
   *   embedP: HTMLElement,
   *   iFrUrl: string,
   *   cdnBaseUrl: string,
   *   useProtocol: string,
   *   zIndex: number | null,
   *   overflow: string | boolean | null,
   *   straightShow: boolean
   * }) => unknown) | null}
   */
  function getStartBadge() {
    var iubendaRuntime = window._iub;

    if (
      !iubendaRuntime ||
      typeof iubendaRuntime !== "object" ||
      !iubendaRuntime.ifr ||
      typeof iubendaRuntime.ifr.iubendaStartBadge !== "function"
    ) {
      return null;
    }

    return iubendaRuntime.ifr.iubendaStartBadge;
  }

  /**
   * @param {string} href
   * @returns {string}
   */
  function getUseProtocol(href) {
    if (href.indexOf("http://") === 0) {
      return "http://";
    }

    if (href.indexOf("https://") === 0) {
      return "https://";
    }

    return "//";
  }

  /**
   * @param {HTMLAnchorElement} link
   * @returns {boolean}
   */
  function openPolicyModal(link) {
    var startBadge = getStartBadge();

    if (!startBadge || !document.body) {
      return false;
    }

    startBadge({
      linkA: link,
      embedP: document.body,
      iFrUrl: link.href,
      cdnBaseUrl: CDN_BASE_URL,
      useProtocol: getUseProtocol(link.href),
      zIndex: parseInt(link.getAttribute("data-iub-z-index") || "", 10) || null,
      overflow: link.getAttribute("data-iub-overflow"),
      straightShow: true,
    });

    return true;
  }

  /**
   * @param {MouseEvent} event
   * @returns {void}
   */
  function handleLinkClick(event) {
    if (!isEnabled() || event.ctrlKey || event.metaKey) {
      return;
    }

    if (!(event.currentTarget instanceof HTMLAnchorElement)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var link = event.currentTarget;
    var href = link.href;

    /**
     * @returns {void}
     */
    function fallbackToPolicyUrl() {
      window.location.href = href;
    }

    /**
     * @returns {void}
     */
    function openWhenReady() {
      loadBadge(function () {
        if (!openPolicyModal(link)) {
          fallbackToPolicyUrl();
        }
      }, fallbackToPolicyUrl);
    }

    if (openPolicyModal(link)) {
      return;
    }

    load(
      openWhenReady,
      fallbackToPolicyUrl,
    );
  }

  return {
    handleLinkClick: handleLinkClick,
  };
})();

window.CustomShopify.Consent = (function () {
  var CONSENT_COOKIE_BASE_NAME = "stc_c";
  var CONSENT_COOKIE_DURATION_DAYS = 360;

  /**
   * @typedef {{
   *   analytics: boolean,
   *   marketing: boolean,
   *   preferences: boolean
   * }} ConsentState
   */

  /**
   * @returns {string}
   */
  function getConsentCookieSuffix() {
    var consentConfig = window.CustomShopify.ConsentConfig;

    if (!consentConfig || typeof consentConfig.cookieSuffix !== "string") {
      return "";
    }

    return consentConfig.cookieSuffix.trim().replace(/\s+/g, "_");
  }

  /**
   * @returns {string}
   */
  function getConsentCookieName() {
    var suffix = getConsentCookieSuffix();

    if (!suffix) {
      return CONSENT_COOKIE_BASE_NAME;
    }

    return CONSENT_COOKIE_BASE_NAME + "_" + suffix;
  }

  /**
   * @returns {boolean}
   */
  function removeOutdatedConsentCookies() {
    var currentCookieName = getConsentCookieName();
    var cookies = document.cookie ? document.cookie.split("; ") : [];
    var removedOutdatedConsentCookie = false;

    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index];

      if (!cookie) {
        continue;
      }

      var separatorIndex = cookie.indexOf("=");
      var cookieName =
        separatorIndex === -1 ? cookie : cookie.slice(0, separatorIndex);

      if (
        cookieName.indexOf(CONSENT_COOKIE_BASE_NAME) === 0 &&
        cookieName !== currentCookieName
      ) {
        window.CustomShopify.Cookies.remove(cookieName);
        removedOutdatedConsentCookie = true;
      }
    }

    return removedOutdatedConsentCookie;
  }

  /**
   * @returns {ConsentState}
   */
  function getDefaultConsentState() {
    return {
      analytics: false,
      marketing: false,
      preferences: false,
    };
  }

  /**
   * @param {unknown} consent
   * @returns {consent is ConsentState}
   */
  function isConsentState(consent) {
    return (
      typeof consent === "object" &&
      consent !== null &&
      "analytics" in consent &&
      "marketing" in consent &&
      "preferences" in consent &&
      typeof consent.analytics === "boolean" &&
      typeof consent.marketing === "boolean" &&
      typeof consent.preferences === "boolean"
    );
  }

  /**
   * @param {ConsentState} consent
   * @returns {void}
   */
  function consentShopify(consent) {
    if (
      !window.Shopify ||
      typeof window.Shopify.loadFeatures !== "function"
    ) {
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      function (error) {
        if (error) {
          console.warn("Shopify Customer Privacy API failed to load.", error);
          return;
        }

        if (
          !window.Shopify.customerPrivacy ||
          typeof window.Shopify.customerPrivacy.setTrackingConsent !==
            "function"
        ) {
          console.warn("Shopify Customer Privacy API is unavailable.");
          return;
        }

        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: consent.analytics,
            marketing: consent.marketing,
            preferences: consent.preferences,
          },
          function (result) {
            if (result && result.error) {
              console.warn("Shopify tracking consent was not saved.", result);
              return;
            }

            console.log("Shopify tracking consent saved.");
          },
        );
      },
    );
  }

  /**
   * @param {ConsentState} consent
   * @param {"default" | "update"} [type]
   * @returns {void}
   */
  function setAnaliticsConsent(consent, type) {
    var consentType = type || "update";
    var gcmValues = {
      ad_storage: consent.marketing ? "granted" : "denied",
      ad_user_data: consent.marketing ? "granted" : "denied",
      ad_personalization: consent.marketing ? "granted" : "denied",
      analytics_storage: consent.analytics ? "granted" : "denied",
      functionality_storage: consent.preferences ? "granted" : "denied",
      personalization_storage: consent.preferences ? "granted" : "denied",
      security_storage: "granted",
    };

    window.dataLayer = window.dataLayer || [];

    /**
     * @returns {void}
     */
    function gtag() {
      window.dataLayer.push(arguments);
    }

    gtag("consent", consentType, gcmValues);

    if (consentType === "update") {
      if (typeof window.uetq !== "undefined") {
        window.uetq = window.uetq || [];
        window.uetq.push("consent", consent.marketing);
      }

      if (typeof window.clarity === "function") {
        window.clarity(consent.analytics ? "consent" : "decline");
      }
    }
  }

  /**
   * @param {ConsentState} consent
   * @param {string} status
   * @param {"default" | "update"} [type]
   * @param {boolean} [syncShopify]
   * @returns {void}
   */
  function ConsentFullSet(consent, status, type, syncShopify) {
    var consentCookieName = getConsentCookieName();

    window.CustomShopify.Cookies.setJson(
      consentCookieName,
      {
        status: status,
        consent: consent,
      },
      CONSENT_COOKIE_DURATION_DAYS,
    );

    if (syncShopify !== false) {
      consentShopify(consent);
    }
    setAnaliticsConsent(consent, type);
  }

  /**
   * @returns {ConsentState}
   */
  function getCurrentConsentScope() {
    var consentCookieName = getConsentCookieName();

    /** @type {{ consent?: unknown } | false} */
    var storedConsent = window.CustomShopify.Cookies.getJson(consentCookieName);

    if (storedConsent === false || !isConsentState(storedConsent.consent)) {
      return getDefaultConsentState();
    }

    return storedConsent.consent;
  }

  /**
   * @returns {"missing" | string}
   */
  function getCurrentConsentStatus() {
    var consentCookieName = getConsentCookieName();

    /** @type {{ status?: unknown, consent?: unknown } | false} */
    var storedConsent = window.CustomShopify.Cookies.getJson(consentCookieName);

    if (storedConsent === false || typeof storedConsent.status !== "string") {
      return "missing";
    }

    if (
      storedConsent.status === "given" &&
      !isConsentState(storedConsent.consent)
    ) {
      return "missing";
    }

    return storedConsent.status;
  }

  /**
   * @returns {void}
   */
  function ConsentDefault() {
    var consentCookieName = getConsentCookieName();

    var removedOutdatedConsentCookie = removeOutdatedConsentCookies();

    /** @type {{ status?: string, consent?: ConsentState } | false} */
    var storedConsent = window.CustomShopify.Cookies.getJson(consentCookieName);

    if (
      storedConsent !== false &&
      storedConsent.status === "given" &&
      isConsentState(storedConsent.consent)
    ) {
      setAnaliticsConsent(storedConsent.consent, "default");
      return;
    }

    ConsentFullSet(
      getDefaultConsentState(),
      "unread",
      "default",
      removedOutdatedConsentCookie,
    );
  }

  return {
    ConsentDefault: ConsentDefault,
    ConsentFullSet: ConsentFullSet,
    consentShopify: consentShopify,
    getCurrentConsentScope: getCurrentConsentScope,
    getCurrentConsentStatus: getCurrentConsentStatus,
    setAnaliticsConsent: setAnaliticsConsent,
  };
})();

window.CustomShopify.Analytics = (function () {
  var HASH_LENGTH = 36;
  var RANDOM_MAX = 1000000;

  /**
   * @typedef {Record<string, unknown> & {
   *   event?: string,
   *   event_name?: string,
   *   name?: string,
   *   custom_event_id?: string
   * }} CustomAnalyticsEvent
   */

  /**
   * @returns {boolean}
   */
  function hasCryptoSupport() {
    return (
      typeof window.crypto !== "undefined" &&
      window.crypto !== null &&
      typeof window.crypto.subtle !== "undefined" &&
      window.crypto.subtle !== null &&
      typeof window.TextEncoder !== "undefined"
    );
  }

  /**
   * @returns {number}
   */
  function getRandomNumber() {
    return Math.floor(Math.random() * RANDOM_MAX) + 1;
  }

  /**
   * @param {ArrayBuffer} buffer
   * @returns {string}
   */
  function bufferToHex(buffer) {
    return Array.from(new Uint8Array(buffer), function (value) {
      return value.toString(16).padStart(2, "0");
    }).join("");
  }

  /**
   * @returns {Promise<string>}
   */
  async function createCustomEventId() {
    var source =
      window.location.href +
      "|" +
      String(Date.now()) +
      "|" +
      navigator.userAgent +
      "|" +
      String(getRandomNumber());

    if (!hasCryptoSupport()) {
      return source
        .replace(/[^a-zA-Z0-9]/g, "")
        .slice(0, HASH_LENGTH)
        .padEnd(HASH_LENGTH, "0");
    }

    var encodedSource = new TextEncoder().encode(source);
    var digest = await window.crypto.subtle.digest("SHA-256", encodedSource);
    return bufferToHex(digest).slice(0, HASH_LENGTH);
  }

  /**
   * @param {CustomAnalyticsEvent} eventObject
   * @returns {string | null}
   */
  function getEventName(eventObject) {
    if (typeof eventObject.event === "string" && eventObject.event.trim()) {
      return eventObject.event.trim();
    }

    if (
      typeof eventObject.event_name === "string" &&
      eventObject.event_name.trim()
    ) {
      return eventObject.event_name.trim();
    }

    if (typeof eventObject.name === "string" && eventObject.name.trim()) {
      return eventObject.name.trim();
    }

    return null;
  }

  /**
   * @param {CustomAnalyticsEvent} eventObject
   * @returns {Promise<CustomAnalyticsEvent>}
   */
  async function enrichEvent(eventObject) {
    var customEventId = await createCustomEventId();

    return Object.assign({}, eventObject, {
      custom_event_id: customEventId,
    });
  }

  /**
   * @param {CustomAnalyticsEvent} eventObject
   * @returns {Promise<CustomAnalyticsEvent>}
   */
  async function pushEvent(eventObject) {
    if (
      !eventObject ||
      typeof eventObject !== "object" ||
      Array.isArray(eventObject)
    ) {
      throw new TypeError("The analytics event payload must be an object.");
    }

    var enrichedEvent = await enrichEvent(eventObject);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(enrichedEvent);

    var eventName = getEventName(enrichedEvent);

    if (
      eventName &&
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === "function"
    ) {
      window.Shopify.analytics.publish(eventName, enrichedEvent);
    }

    return enrichedEvent;
  }

  return {
    createCustomEventId: createCustomEventId,
    enrichEvent: enrichEvent,
    pushEvent: pushEvent,
  };
})();
